import { h, Component } from "preact";
import { route } from "preact-router";
import Config from "../../config";
import User from "../../../../services/user";
import Page from "../../../../services/page-data-feed";
import MobilePage from "../../utils/mobile-page";

import { UserIcon, UserMenuIcon } from "../../mobile-templates/general";
import { msg } from "@lingui/core/macro";
import { DepositIcon } from "../../utils/icons";

export default function Header() {
	return (
		<div class="z-10 h-12">
			<div class="fixed z-10 flex h-12 w-full bg-blue-whale-600 text-white border-b border-blue-whale-800">
				<div class="flex w-12 items-center justify-center p-2.5" onClick={(e) => { MobilePage.openLeftMenu(); }}>
					<HamburgerIcon />
				</div>
				<div class="flex grow items-center justify-start py-1.5">
					<a class="flex items-center relative h-full" href="/">
						<img src={Config.logourl} alt={Config.title} class="max-h-full" />
					</a>
				</div>
				{User.isLogged() ? <LoggedUserBox /> : <GuestUserBox />}
			</div>
		</div>
	);
}


function HamburgerIcon() {
	return <svg
		class="fill-current h-7"
		viewBox="0 0 64 64"
		xmlns="http://www.w3.org/2000/svg"
		style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2"
	>
		<path style="fill:none" d="M0 0h1280v800H0z" transform="translate(-1024 -192)" />
		<path
			style="fill-rule:nonzero"
			d="M103.288 8.535h212.447v34.133H103.288z"
			transform="matrix(.2251 0 0 .17555 -15.24765192 42.35286814)"
		/>
		<path
			style="fill-rule:nonzero"
			d="M103.288 8.535h212.447v34.133H103.288z"
			transform="matrix(.2251 0 0 .17555 -15.0379454 27.431458)"
		/>
		<path
			style="fill-rule:nonzero"
			d="M103.288 8.535h212.447v34.133H103.288z"
			transform="matrix(.2251 0 0 .17555 -15.0379454 12.51004786)"
		/>
	</svg>
}

function GuestUserBox() {
	return (
		<div class="flex w-52 flex-shrink-0 items-center justify-center gap-1 pr-1 py-px">
			<LoginButton />
			<RegisterButton />
		</div>
	);
}

function LoginButton({ ...props }) {
	return <input
		type="button"
		class="form-button w-24 py-1 leading-7 rounded hover:cursor-pointer bg-green-600 border-green-900 border text-gray-100 text-sm uppercase font-bold" {...props}
		value={window.Translation(msg`Accedi`)}
		onClick={(e) => { route('#login'); window.dispatchEvent(new Event('hashchange')); }}
	/>
}

function RegisterButton({ ...props }) {
	return <input
		type="button"
		class="form-button w-24 py-1 leading-7 rounded hover:cursor-pointer bg-kobaaccent-500 border-kobaaccent-900 border text-gray-100 text-sm uppercase font-bold" {...props}
		value={window.Translation(msg`Registrati`)}
		onClick={(e) => { route('#register'); window.dispatchEvent(new Event('hashchange')); }}
	/>
}

function LoggedUserBox() {
	return (
		<div class="flex items-center gap-2 px-2.5">
			<a class="bg-kobaaccent-600 text-sm border rounded border-kobaaccent-700 px-2 py-1 shadow flex gap-1 items-center" href="/user/payment-gateway/deposit">
				<DepositIcon class="h-4 relative -top-0.5" />
				<span class="uppercase">Deposit</span>
			</a>
			<div class="flex w-8 flex-col items-center justify-center py-1" onClick={(e) => { MobilePage.openRightMenu(); }}>
				<UserMenuIcon class="h-8" />
			</div>
		</div>
	);
}



